import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AccountListRequestBody, AccountListResponse } from "./types";

export class AccountListAPI extends BaseAPI<
  AccountListRequestBody,
  AccountListResponse
> {
  protected route = ApiRoutes.account.list;
  protected method = RequestMethod.GET;
  protected params = ["sort_key", "sort_order"];
}
